import { List } from 'immutable';
import { actions } from './actions';
import { createEmployee, setEmployeeClockState, updateClockedInList } from './lib';

const initialState = new List();

export default function reducer(state = initialState, { type, value }) {
  switch (type) {
    case actions.SET:
      return new List(value.map(employee => createEmployee(employee)));
    // i'm not sure when ADD or REMOVE are ever going to be needed manually.
    case actions.ADD:
      return state.push(createEmployee(value));
    case actions.REMOVE:
      return state.filter(employee => employee.get('id') !== value);
    case actions.CLOCK_IN:
      return setEmployeeClockState(state, value, 'in');
    case actions.CLOCK_OUT:
      return setEmployeeClockState(state, value, 'out');
    case actions.UPDATE_CLOCKED_IN:
      return updateClockedInList(state, value);
    case actions.CLEAR:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/employees/reducer.js